// import { ICustomer } from "./models/customer";
import { IFacility } from "../models/facility";
import { FACILITY_DISPATCH_TARGET_CLIENT_FACILITY } from "redux/facilityDispatchMeta";

export interface IClientFacilityStore {
  isLoaded: boolean;
  error?: any;
  facility?: IFacility;
  facilities?: Array<IFacility>;
  weather?: any;
  paymentOptions: any[];
}

export interface IFacilityAction {
  type: string;
  payload: Partial<IClientFacilityStore>;
  meta?: { facilityDispatchTarget?: typeof FACILITY_DISPATCH_TARGET_CLIENT_FACILITY };
}

const initialState: IClientFacilityStore = {
  isLoaded: false,
  error: null,
  facility: null,
  facilities: null,
  weather: null,
  paymentOptions: [],
};

export default function FacilityReducer(state = initialState, action: IFacilityAction) {
  switch (action.type) {
    case "facility.update":
      if (action.meta?.facilityDispatchTarget !== FACILITY_DISPATCH_TARGET_CLIENT_FACILITY) {
        return state;
      }
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
